import * as THREE from 'three'
import { useFrame } from '@react-three/fiber'
import { useAppStore } from 'startup/appStore'
import { useShallow } from 'zustand/react/shallow'

export default function useFlight(animalName, actionName, actions) {

    const MAX_DISTANCE = 10;

    const { 
        gameStatus,
        player,
        currentPosition,
        setPositions,
        setRotation,
        setAction,
        setMovements,
        effectiveTimeScale,
    } = useAppStore( useShallow((state) => ({
        gameStatus: state.gameStatus,
        player: state.player,
        currentPosition: state.positions[animalName]?.current,
        setPositions: state.setPositions,
        setRotation: state.setRotation,
        setAction: state.setAction,
        setMovements: state.setMovements,
        effectiveTimeScale: state.effectiveTimeScales[animalName],
    })));

    const direction = new THREE.Vector3();
    const rotation = new THREE.Euler(0, 0, 0, 'YXZ');
    const currentPositionClone = currentPosition.clone();

    let directionX, directionZ, stepCountX, stepCountZ;

    useFrame((state, delta) => {
        if (gameStatus === 'start' && player === 'fox') {

            directionX = useAppStore.getState().movements[animalName].directionX;
            directionZ = useAppStore.getState().movements[animalName].directionZ;

            stepCountX = useAppStore.getState().movements[animalName].stepCountX;
            stepCountZ = useAppStore.getState().movements[animalName].stepCountZ;

            if (currentPosition.x > MAX_DISTANCE) setMovements(animalName, 'directionX', -1);
            if (currentPosition.x < -MAX_DISTANCE) setMovements(animalName, 'directionX', 1);
            if (currentPosition.z > MAX_DISTANCE) setMovements(animalName, 'directionZ', -1);
            if (currentPosition.z < -MAX_DISTANCE) setMovements(animalName, 'directionZ', 1);

            // always move 10 steps in one direction, then 10 steps in the other direction
            if (stepCountX > 0 && stepCountX < 10) {
                direction.x = directionX;
                setMovements(animalName, 'stepCountX', stepCountX + 1);
            } else if (stepCountZ > 0 && stepCountZ < 10) {
                direction.z = directionZ;
                setMovements(animalName, 'stepCountZ', stepCountZ + 1);
            } else if (stepCountX === 10) {
                direction.z = directionZ;
                setMovements(animalName, 'stepCountZ', 1);
                setMovements(animalName, 'stepCountX', 0);
            } else if (stepCountZ === 10) {
                direction.x = directionX;
                setMovements(animalName, 'stepCountX', 1);
                setMovements(animalName, 'stepCountZ', 0);
            } else {
                direction.x = directionX;
                setMovements(animalName, 'stepCountX', 1);
            }

            currentPositionClone.z += direction.z * delta * effectiveTimeScale;
            currentPositionClone.x += direction.x * delta * effectiveTimeScale;
            setPositions(animalName, currentPositionClone)

            rotation.y = Math.atan2(direction.x, direction.z);
            setRotation(animalName, rotation)

            actions['die']?.stop();

            actions[actionName].
                setLoop(THREE.LoopRepeat).
                setEffectiveTimeScale(effectiveTimeScale).
                play();
        }
    });
};

